import ConstructorIOClient from '@constructor-io/constructorio-client-javascript';
import getConfig from 'next/config';
import { createContext, useEffect, useState } from 'react';

import { CONSTRUCTOR_SERVICE_URL } from 'search/enums/constants';

export const ConstructorContext = createContext(null);

export const ConstructorProvider = ({ children }) => {
  const { publicRuntimeConfig } = getConfig();
  const [constructorClient, setConstructorClient] = useState(null);

  useEffect(() => {
    if (!constructorClient) {
      const constructorIo = new ConstructorIOClient({
        apiKey: publicRuntimeConfig.CONSTRUCTOR_API_KEY,
        sendTrackingEvents: true,
        serviceUrl: CONSTRUCTOR_SERVICE_URL,
        idOptions: {
          client_id_storage_location: 'cookie',
          session_id_storage_location: 'cookie',
        },
      });

      void setConstructorClient(constructorIo);
      void constructorIo.tracker.trackSessionStart();
    }
  }, []);

  return (
    <ConstructorContext.Provider value={constructorClient}>{children}</ConstructorContext.Provider>
  );
};
